export const ANONYMOUS_QUERY_SCOPE = "anonymous";

type ReportingDashboardKeyParams = {
	from: string;
	to: string;
	scope: string;
	filter: string;
};

export const entryQueryKeys = {
	root: ["entry-data"] as const,
	user: (userId?: string) =>
		[...entryQueryKeys.root, userId ?? ANONYMOUS_QUERY_SCOPE] as const,
	entries: (userId?: string) =>
		[...entryQueryKeys.user(userId), "entries"] as const,
	entryList: (userId: string | undefined, scopeKey: string) =>
		[...entryQueryKeys.entries(userId), scopeKey] as const,
	calendarSummaries: (userId?: string) =>
		[...entryQueryKeys.user(userId), "calendar-summaries"] as const,
	calendarSummary: (userId: string | undefined, scopeKey: string) =>
		[...entryQueryKeys.calendarSummaries(userId), scopeKey] as const,
	reportingDashboards: (userId?: string) =>
		[...entryQueryKeys.user(userId), "reporting-dashboards"] as const,
	reportingDashboard: (
		userId: string | undefined,
		{ from, to, scope, filter }: ReportingDashboardKeyParams,
	) =>
		[
			...entryQueryKeys.reportingDashboards(userId),
			from,
			to,
			scope,
			filter,
		] as const,
};
